module.exports = __webpack_public_path__ + "static/img/jigou-2-top.2daee11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou-2-top.png
// module id = GHc/
// module chunks = 2